export default __webpack_public_path__ + "static/media/lead-score.43356cbd.svg";